type BannerHeaderProps = {
    children: React.ReactNode;
};

export default function BannerHeader({ children }: BannerHeaderProps) {
    return (
        <h1 className='text-primary text-3xl md:text-4xl lg:text-6xl uppercase'>
            {children}
        </h1>
    );
}
